import React from 'react';
import HashHero from 'hash-heroes';
import './Background.css';

const Background = () => (
    <div className="background">
        <div className="mountain"></div>
        <div className="mountain two"></div>
        <div className="hero1">
            <HashHero seed="0xa12341678dabedef012a456789ebcaee0d234017" scalingFactor={4} />
            <HashHero seed="0xa12341678dabedef012a456789ebcaee0d235611" scalingFactor={4} />
        </div>
    </div>
);

export default Background;

// <HashHero seed="0xa12341678dabedef012a456789ebcaee0d234470" scalingFactor={4} />
//             <HashHero seed="0xa12341678dabedef012a456789ebcaee0d232236" scalingFactor={4} />



// WEBPACK FOOTER //
// ./src/components/Background.js